import { useQuery, UseQueryOptions } from 'react-query';
import { getProductScope } from '@discover-frontend/utils';

import { STANLEY_QUERY_KEYS } from '../constants';
import { fetchStanleyQueryCredits } from '../request';
import { StanleyQueryCreditsData } from '../types';

export const useStanleyQueryCredits = (
  options?: Omit<
    UseQueryOptions<StanleyQueryCreditsData>,
    'queryKey' | 'queryFn'
  >
) => {
  const scope = getProductScope();

  return useQuery<StanleyQueryCreditsData>(
    [STANLEY_QUERY_KEYS.GET_CREDITS, scope],
    fetchStanleyQueryCredits,
    options
  );
};
